import { render } from "./EnterGame.vue?vue&type=template&id=8f97a08e&scoped=true"
import script from "./EnterGame.vue?vue&type=script&lang=js"
export * from "./EnterGame.vue?vue&type=script&lang=js"

import "./EnterGame.vue?vue&type=style&index=0&id=8f97a08e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f97a08e"]])

export default __exports__